import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import { useArgonController } from "context";

function DetailedStaticsCard({
  bgColor,
  title,
  count,
  percentage,
  direction,
  noPercent,
}) {
  const [controller] = useArgonController();
  const { darkMode } = controller;

  const titleColor = bgColor === "white" ? "text" : "white";

  return (
    <Card>
      <ArgonBox
        bgColor={bgColor === "white" && darkMode ? "transparent" : bgColor}
        variant={bgColor === "white" && darkMode ? "contained" : "gradient"}
      >
        <ArgonBox p={2}>
          <Grid container>
            <Grid item xs={12}>
              <ArgonBox lineHeight={1}>
                <ArgonTypography
                  variant="button"
                  color={titleColor}
                  fontWeight="bold" // changed from medium to bold
                >
                  {title}
                </ArgonTypography>
                <ArgonTypography
                  variant="h4"
                  fontWeight="bold"
                  color={bgColor === "white" ? "dark" : "white"}
                  mt={1}
                  mb={0}
                >
                  {count}
                </ArgonTypography>
              </ArgonBox>
            </Grid>
          </Grid>

          {percentage && percentage.count !== undefined ? (
            <ArgonTypography
              display="flex"
              alignItems="center"
              variant="button"
              fontWeight={noPercent ? "bold" : "bold"}
              color={noPercent ? titleColor : "success"}
              mt={1}
            >
              {percentage.count}
              <ArgonTypography
                variant="body3"
                fontWeight="regular"
                opacity={0.6}
                ml={1}
              >
                {percentage.text}
              </ArgonTypography>
            </ArgonTypography>
          ) : null}
        </ArgonBox>
      </ArgonBox>
    </Card>
  );
}

DetailedStaticsCard.defaultProps = {
  bgColor: "white",
  percentage: {
    color: "success",
    count: 0,
    text: "",
  },
  direction: "right",
  noPercent: false,
};

DetailedStaticsCard.propTypes = {
  bgColor: PropTypes.oneOf([
    "transparent",
    "white",
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  percentage: PropTypes.shape({
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    text: PropTypes.string,
  }),
  direction: PropTypes.oneOf(["right", "left"]),
  noPercent: PropTypes.bool,
};

export default DetailedStaticsCard;
